var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 43.338H70.3477L41.7158 71.8633L47.833 78L87 39.0212L47.833 0L41.7158 6.13673L70.3477 34.662H0V43.338Z"}));
}

ArrowInline.defaultProps = {"viewBox":"0 0 87 78","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
